import { useMemo } from 'react';

import { Image } from '../../image/image.component';
import { Button } from '../../button/button.component';

import { OneColumnContentProps } from './one-column-content.config';

const OneColumnContent = ({ appliedCssClassNames, cta, image }: OneColumnContentProps) => {
  const hasGradientBackground = useMemo(
    () => appliedCssClassNames === 'snowflake-column-container-gradient-bg',
    [appliedCssClassNames]
  );

  return (
    <div data-testid="snowflake-one-column-content" className="snowflake-one-column-content">
      {image && (
        <div className="snowflake-one-column-content-image" data-testid="snowflake-one-column-content-image">
          <Image {...image} baseCssClass="cmp-image" />
        </div>
      )}
      {cta && (
        <div
          className={`snowflake-one-column-content-cta snowflake-button-primary snowflake-button-regular snowflake-button-${
            hasGradientBackground ? 'white' : 'blue'
          }`}
          data-testid="snowflake-one-column-content-cta"
        >
          <Button {...cta} />
        </div>
      )}
    </div>
  );
};

export default OneColumnContent;
